import { DiscountTypeEnum } from 'app/api/marketing/discount-campaign/model'
import { IPayLoadGetList } from 'app/common/interface'
import { IClinic } from 'app/model/unit.model'
import R from 'app/assets/R'
import { ResponseType } from 'parkway-web-common'
import { Dayjs } from 'dayjs'

interface IPatient {
  _id: string
  name: string
  contact: string
  id: string
  link: string
}

interface ITreatment {
  name: string
  paymentMethod: string
}

export interface ICampaign {
  _id: string
  name: string
  priority: number

  isStackedDiscount?: boolean
}

interface IVoucher {
  discountType: EDiscountType
  amount: number
  code?: string
  cash?: number
  expiredDate?: string
  startDate?: string
}

enum EDiscountType {
  Percent = 'percent',
  Amount = 'amount',
}

export enum RangeTimeEnum {
  CHOOSE_DAY = 'choose_day',
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  THIS_WEEK = 'this_week',
  LAST_WEEK = 'last_week',
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  THIS_YEAR = 'this_year',
}

export interface IParamsGetReport18 extends IPayLoadGetList {
  startDate?: string
  endDate?: string
  startDateDayJs?: Dayjs | null
  endDateDayJs?: Dayjs | null
  keyword?: string
  clinicIds?: string[]
  campaignIds?: string[]
  year?: string
  quarter?: string
  month?: string
  week?: string

  rangeTime?: RangeTimeEnum
  voucherCodes?: string[]
  treatmentIds?: string[]
}

export interface IReport018 {
  date?: string
  clinic?: IClinic
  patient?: IPatient
  treatmentId?: string
  treatment?: ITreatment
  treatmentGroup?: {
    name?: string
  }
  used?: number
  retailPrice?: number
  discountedTotal?: number
  voucherId?: string
  voucher?: IVoucher
  campaign?: ICampaign

  // more item
  rebatedAmount?: number
  deductedAmount?: number
  discountedAmount?: number
}

export const DefineDiscountTypeEnum = {
  [DiscountTypeEnum.Percent]: {
    keyI18n: R.strings.percent,
  },
  [DiscountTypeEnum.Amount]: {
    keyI18n: R.strings.cash,
  },
}
export type ResponseReport18Type = ResponseType<IReport018[]>
